import Icon from "@components/global/new/Icon/Icon";
import cn from "classnames";
import styles from "./Equipment.module.scss";

import del from "@assets/icons/delete.svg";
import edit from "@assets/icons/edit.svg";
import networkIcon from "@assets/icons/network.svg";
import NodeIcon from "@components/ConnectionsEditor/NodeIcon";
import { nodesDescriptionMap } from "@components/ConnectionsEditor/nodes";
import { MODALS_ENUM } from "@constants/Modals";
import { IEquipmentModal3Props } from "@mobx/components/EquipmentModal3";
import usePlaceID3 from "@mobx/hooks/usePlaceID";
import connectionsStore from "@mobx/store/connections";
import { DRAGGING_TYPES3, IEquipmentTemplate } from "@mobx/store/locations/types";
import { isWorkEquipment } from "@store/Equipments/actionTypes";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { makeNotifs } from "@utils/makeNotifs";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";

export interface IEquipment3Props {
  readonly eq: IEquipmentTemplate;
  readonly last?: boolean;
}

type DragEventType3 = React.DragEvent<HTMLDivElement>;

const useControl = (
  props: IEquipment3Props
) => {
  const { ok } = makeNotifs();
  const dispatch = useDispatch();
  const { onSuccess, } = useGlobalNotifs();
  const icon = useMemo(
    () => 
      (isWorkEquipment(props.eq) && props.eq.subtype !== undefined)
      ? nodesDescriptionMap[props.eq.subtype].icon
      : networkIcon,
    [props.eq],
  )
  const { placeID } = usePlaceID3(true);
  const actions = placeID ? connectionsStore.getPlaceStore(placeID) : undefined;

  const onEditEquipment = () => {
    dispatch(
      show(MODALS_ENUM.EQUIPMENT_MODAL, {
        templateEq: props.eq,
        placeID: placeID,
        showTypeSelector: true,
      } as IEquipmentModal3Props)
    );
  };

  const onDeleteEquipment = () => {
    dispatch(
      show(MODALS_ENUM.CONFIRM_MODAL, {
        onConfirm: () => {
          actions?.removeNode(props.eq.id);
          onSuccess(ok.success);
        },
      })
    );
  };

  const onDragStart = (e: DragEventType3) => {
    const data = JSON.stringify(props.eq);
    e.dataTransfer.setData(DRAGGING_TYPES3.AVAILABLE_EQUIPMENT, data);
  };

  return {
    icon,
    onEditEquipment,
    onDeleteEquipment,
    onDragStart,
  };
};

const Equipment3 = (props: IEquipment3Props) => {
  const control = useControl(props);

  return (
    <div
      className={cn(styles.wrapper, { [styles.last]: !!props.last })}
      onDragStart={control.onDragStart}
      title={props.eq.name}
      draggable
    >
      <NodeIcon icon={control.icon} color={props.eq.color} size={20} />
      <p style={{ color: "black" }}>{props.eq.name}</p>
      <Icon
        src={edit}
        className={cn(styles.icon, styles.edit)}
        onClick={control.onEditEquipment}
      />
      <div className={cn(styles.icon, styles.delete)}>
        <Icon
          src={del}
          className={styles.del_icon}
          onClick={control.onDeleteEquipment}
          noHover
        />
      </div>
    </div>
  );
}

export default Equipment3;
